import { useEffect, useState } from 'react';

// Currency input matching the Eadin design system — auto $ prefix + thousands
// commas ($4,543.00), formats on blur. No number spinners.
const formatCurrency = (raw) => {
    const n = parseFloat(String(raw).replace(/[^0-9.-]/g, ''));
    if (Number.isNaN(n)) return '';
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const parseCurrency = (display) => {
    const cleaned = String(display).replace(/[^0-9.-]/g, '');
    const n = parseFloat(cleaned);
    return Number.isNaN(n) ? '' : String(n);
};

export const CurrencyInput = ({
    value,
    onValueChange,
    className = '',
    disabled,
    placeholder = '$0.00',
    autoFocus,
    testId
}) => {
    const [display, setDisplay] = useState(value ? formatCurrency(value) : '');
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        if (!focused) setDisplay(value ? formatCurrency(value) : '');
    }, [value, focused]);

    return (
        <input
            type="text"
            inputMode="decimal"
            value={display}
            disabled={disabled}
            placeholder={placeholder}
            autoFocus={autoFocus}
            data-testid={testId}
            onFocus={() => setFocused(true)}
            onChange={(e) => {
                const v = e.target.value.replace(/[^0-9.,$-]/g, '');
                setDisplay(v);
                onValueChange(parseCurrency(v));
            }}
            onBlur={() => {
                setFocused(false);
                setDisplay(value ? formatCurrency(value) : '');
            }}
            className={`tabular-nums text-sm border-gray-300 rounded-md ${className}`}
        />
    );
};
